/*
 * @Author: qiuz
 * @Date: 2018-05-24 15:28:32
 * */

import './index.less';

import * as React from 'react';
import { withRouter } from 'react-router-dom';

interface Props {
	history: any;
}

@(withRouter as any)
export default class Layout extends React.Component<Props, any> {

	constructor(props: any) {
		super(props);
		this.state = {
			bodyHeight: { height: '100%' },
		}
	}


	onLeftClick = () => {
		this.props.history.go(-1);
	}

	componentDidMount() {

	}

	render() {
		return (
			<div className="layout">
				<header></header>
				<div className="main">
					{this.props.children}					
				</div>
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./src/component/layout/index.tsx